module.exports = __webpack_public_path__ + "static/media/card2.e4028abb.svg";